import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SentimentDissatisfiedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sentiment_dissatisfied"}/>
}
